<template>
  <div id="contenedor-main-contratistas-contratos">
    <v-container fluid>
      <v-card flat class="mb-4">
        <v-card-text>
          <TituloToolBar titulo="Contratos"></TituloToolBar>
          <v-toolbar flat>
            <div style="width: 150px" class="mr-2">
              <custom-select
                v-model="filtros.ejercicio"
                :items="getEjercicios"
                label="Ejercicio">
              </custom-select>
            </div>
            <div style="width: 350px" class="mr-2">
              <custom-text-field
                v-model="filtros.buscar"
                label="Buscar..."
                append-icon="mdi-magnify"
                clearable>
              </custom-text-field>
            </div>
          </v-toolbar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody">
          </v-skeleton-loader>
          <ListadoContratos
            v-else
            :listado-contratos="contratosSupervisionExternas">
          </ListadoContratos>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import CONTRATOS_SUPERVISION_EXTERNAS from '@/graphql/querys/contratiastas/contratosSupervisionExternas.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import ListadoContratos from './Listado.vue';

export default {
  name: 'DefaultContratistasContratos',
  components: {
    TituloToolBar,
    ListadoContratos,
    CustomSelect,
    CustomTextField,
  },
  data() {
    return {
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscar: null,
      },
    };
  },
  apollo: {
    contratosSupervisionExternas: {
      query: CONTRATOS_SUPERVISION_EXTERNAS,
      variables() {
        return {
          filtros: {
            ejercicio: this.filtros.ejercicio,
            buscarTexto: this.filtros.buscar,
          },
        };
      },
    },
  },
  computed: {
    getEjercicios() {
      const hoy = new Date();
      const esteEjercicio = hoy.getFullYear();
      return this.$range((esteEjercicio - 3), (esteEjercicio + 1)).reverse();
    },
  },
};
</script>

<style lang="scss">

</style>
